import { useToast } from "@/hooks/use-toast";
import { Spinner } from "@phosphor-icons/react";
import { useStytch } from "@stytch/react";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROOT } from "@/lib/links";
import { useTranslation } from "react-i18next";

function Logout() {
  const { t } = useTranslation("auth");
  const stytch = useStytch();
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();
  const logout = () => {
    stytch.session.revoke().then(() => {
      toast.toast({
        title: t("logout.toast.title"),
        description: t("logout.toast.description"),
      });

      navigate(ROOT);
      queryClient.removeQueries({
        queryKey: ["user"],
      });
      queryClient.invalidateQueries({
        queryKey: ["init"],
      });
      queryClient.refetchQueries({
        queryKey: ["init"],
      });
      window.sessionStorage.clear();
      window.localStorage.removeItem("tchr_client_key");
    });
  };

  useEffect(() => {
    logout();
  }, []);

  return (
    <div className="flex flex-row items-center justify-center w-full h-full space-x-4 text-4xl">
      <Spinner className="animate-spin" />
      <h1>{t("logout.title")}</h1>
    </div>
  );
}

export default Logout;
